import { render, staticRenderFns } from "./ContainerGray.vue?vue&type=template&id=57e84def"
import script from "./ContainerGray.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerGray.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports